import { MaintenanceRequester } from '@cobliteam/api-lib';
import type { VehicleOdometer } from '@cobliteam/api-lib/src/__generated__/graphql';
import { Environment } from '@cobliteam/react-environments';
import { useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getMaintenanceRequester = () =>
  new MaintenanceRequester({
    host: env.herbieApiHost,
  });

const QUERY_KEY = 'fleet_odometers';

const getFleetOdometers = () => {
  return useQuery<VehicleOdometer[]>({
    queryKey: [`${QUERY_KEY}`],
    queryFn: () => getMaintenanceRequester().getFleetOdometers(),
    refetchOnMount: false,
  });
};

export default { getFleetOdometers };
